import { msgid, ngettext, t } from 'ttag';

export function roundToFive(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const mins = Math.round((minutes % 60) / 5) * 5;

  const result: string[] = [];

  if (hours) {
    result.push(ngettext(msgid`${hours} hour`, `${hours} hours`, hours));
  }
  if (mins) {
    result.push(t`${mins} minutes`);
  }

  return result.join(t` and `) || t`no time at all`;
}
